export const HourMinValidation = (value) => {
    const validation = new RegExp(/^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/);
    return validation.test(value);
}